export interface RoleConstants {
  GlobalRoleIdentifier: string;
}

export const roleConstants: RoleConstants = {
  GlobalRoleIdentifier: "0"
};
